<template>
  <div>
    <LandingHeader />

    <main>
      <section id="hero">
        <HeroSection />
      </section>

      <section id="features">
        <FeatureSection />
      </section>

      <TabbedBentoSection />

      <section id="integrations">
        <IntegrationSection />
      </section>

      <section id="faq">
        <FAQSection />
      </section>

      <section id="pricing">
        <PricingSection :addons />
      </section>

      <CTASection />
    </main>

    <!-- Footer -->
    <footer class="bg-gray-50">
      <FooterSection />
    </footer>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import LandingHeader from "@/Components/LandingHeader.vue";
import HeroSection from "@/Components/Welcome/HeroSection.vue";
import FeatureSection from "@/Components/Welcome/FeatureSection.vue";
import TabbedBentoSection from "@/Components/Welcome/TabbedBentoSection.vue";
import IntegrationSection from "@/Components/Welcome/IntegrationSection.vue";
import FAQSection from "@/Components/Welcome/FAQSection.vue";
import PricingSection from "@/Components/Welcome/PricingSection.vue";
import CTASection from "@/Components/Welcome/CTASection.vue";
import FooterSection from "@/Components/Welcome/FooterSection.vue";
import { Addon } from "@/types/addon";

interface Props {
  addons: Addon[];
}

defineProps<Props>();

onMounted(async () => {
  if (!("scrollBehavior" in document.documentElement.style)) {
    const smoothscroll = await import("smoothscroll-polyfill");
    smoothscroll.polyfill();
  }
});
</script>

<style>
html {
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}
</style>
